import { createContext, useContext, useEffect, useMemo, useState } from "react";
import api from "@/lib/api";

const AuthCtx = createContext(null);
export const useAuth = () => useContext(AuthCtx);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);      // null=checking
  const [tenant, setTenant] = useState(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    api.get("/auth/me")
      .then(({ data }) => { setUser(data.user); setTenant(data.tenant); })
      .catch((e) => { if (e?.response?.status !== 401) console.error("Session check failed", e); })  // 401 = not logged in yet
      .finally(() => setReady(true));
  }, []);

  const value = useMemo(() => ({
    user, tenant, ready, setTenant,
    login: (_token, u, t) => { setUser(u); setTenant(t); },
    logout: async () => {
      try { await api.post("/auth/logout"); } catch { /* cookie already gone */ }
      setUser(null); setTenant(null);
      window.location.href = "/login";
    },
    switchTenant: async (tenant_id) => {
      const { data } = await api.post("/auth/switch-tenant", { tenant_id });
      setTenant(data.tenant);
      window.location.reload();
    },
  }), [user, tenant, ready]);

  return <AuthCtx.Provider value={value}>{children}</AuthCtx.Provider>;
}
